import { inEnum, isObject, isString } from "@ciaopeople/cp-shatsu/TypeChecking";
import { CPProductName } from "../../../config/CPProducts.js";
import { YM_Category } from "../../../model/MediaMetaData.js";

export enum CP_SexValue {

    MALE = "m",
    FEMALE = "f",
    UNKNOWN = "u"

}


export enum CP_ContentValue {
    HOT = "hot"
}


export type CP_NumericBoolean = 0 | 1;

export enum CP_DeviceTypeValue {


    MOBILE = "mobile",
    DESKTOP = "desktop",
    TABLET = "tablet"

}


export enum CP_InAppBrowserValue {
    FANPAGE_APP = "fanpageapp",
    COOKIST_IT_APP = "cookist_itapp",
    COOKIST_COM_APP = "cookist_wowapp",
    GEOPOP_APP = "geopopapp",
    WAMILY_APP = "wamilyapp",
    LEXPLAIN_APP = "lexplainapp",
    KODAMI_APP = "kodamiapp",
    SAFARI = "safari",
    ANDROID_WEBVIEW = "webview",
    NO = "no"
}


export enum CP_EmbedType {

    EMBED_GNEWS = "embed_GNEWS",
    VIDEO = "video",
    VIDEO_TESTO = "video_testo",
    VIDEO_TINT = "video_tint",
    GALLERY = "gallery",
    FANPLAYER = "fanplayer",
    FANPLAYER_AMP = "fanplayer_AMP",
    EMBED_EXT = "embed_ext",
    EMBED = "embed",
    EMBED_AMP = "embed_AMP",

    PODCAST_ARTICLE = "articolo_podcast",
    PODCAST_EMBED = "embed_podcast",

    FANPLAYER_ILOVECALCIO = "ilc_fanplayer",
    FANPLAYER_YOULIKE = "yl_fanplayer",
    FANPLAYER_GOQUIZ = "gq_fanplayer",
    FACEBOOK = "facebook",

    EMBED_INTERNAL = "embed_internal",
    FLASH_CAROUSEL = "flash_carousel"


}

export enum CP_AdvSiteName {

    FANPAGE = "fanpage",
    COOKISTIT = "ck_it",
    COOKISTWOW = "ck_wow",
    COOKISTLEGAL = "ck_legal",
    OHGA = "ohga",
    KODAMI = "kodami",
    GEOPOP = "geopop",
    WAMILY = "wamily",
    LEXPLAIN = "lexplain"
}


const prodMap: Record<CPProductName, CP_AdvSiteName> = {
    COOKIST: CP_AdvSiteName.COOKISTIT,
    COOKIST_WOW: CP_AdvSiteName.COOKISTWOW,
    OHGA: CP_AdvSiteName.OHGA,
    FANPAGE: CP_AdvSiteName.FANPAGE,
    KODAMI: CP_AdvSiteName.KODAMI,
    LEXPLAIN: CP_AdvSiteName.LEXPLAIN,
    GEOPOP: CP_AdvSiteName.GEOPOP,
    WAMILY: CP_AdvSiteName.WAMILY

}

export function getAdvSiteNameFromProduct(prod: CPProductName): CP_AdvSiteName {
    return prodMap[prod];
}


export enum CP_FanpageValue {

    calcio = "calcio",
    motori = "motori",
    music = "music",
    tv = "tv",
    cinema = "cinema",
    gossip = "gossip",
    donna = "donna",
    design = "design",
    travel = "travel",
    scienze = "scienze",
    tech = "tech",
    wamily = "wamily",
    kodami = "kodami",
    roma = "roma",
    milano = "milano",
    napoli = "napoli",
    sport = "sport",
    www = "www",
    poker = "poker",
    games = "games",
    job = "job"

}

const ymCategoryFanpageValueMap: Record<YM_Category, CP_FanpageValue> = {
    Cucina: CP_FanpageValue.www,
    Viaggi: CP_FanpageValue.travel,
    Tecnologia: CP_FanpageValue.tech,
    Scienze: CP_FanpageValue.scienze,
    Design: CP_FanpageValue.design,
    Sport: CP_FanpageValue.sport,
    Rugby: CP_FanpageValue.sport,
    Musica: CP_FanpageValue.music,
    Motori: CP_FanpageValue.motori,
    Donna: CP_FanpageValue.donna,
    Spettacolo: CP_FanpageValue.gossip,
    Politica: CP_FanpageValue.www,
    Cronaca: CP_FanpageValue.www,
}

export function getFanpageValueFromYMCategory(ym_category: YM_Category): CP_FanpageValue {
    return ymCategoryFanpageValueMap[ym_category];
}

export function getFanpageValueFromExternalArea(cat: string): CP_FanpageValue {
    if (inEnum(cat, CP_FanpageValue)) {
        return cat;
    }
    return CP_FanpageValue.www;
}

/**
 * Ciaopeople Managed Custom Params
 */
export type CustomParams = {
    type?: CP_EmbedType,
    site?: CP_AdvSiteName,
    url?: string,
    category?: string,
    inappbrowser?: CP_InAppBrowserValue,
    device_category?: CP_DeviceTypeValue,
    fanpage?: CP_FanpageValue
    page?: string,
    age?: number,
    sex?: CP_SexValue,
    paragraph_number?: number,
    user?: string,
    content?: CP_ContentValue,
    story?: string,
    utm_medium?: string,
    utm_source?: string,
    utm_campaign?: string,
    num_session_page_views?: number,
    amznbid?: string,
    fptst?: CP_NumericBoolean,
    audio?: "on" | "off",
    vpmute?: 1 | 0,
    contesto_browser?: string
};





export function isMinimumViableCustomParams(a: any): a is CustomParams {
    return isObject(a) &&
        ("type" in a && inEnum(a.type, CP_EmbedType)) &&
        ("site" in a && inEnum(a.site, CP_AdvSiteName)) &&
        ("url" in a && isString(a.url)) &&
        ("inappbrowser" in a && inEnum(a.inappbrowser, CP_InAppBrowserValue)) &&
        ("device_category" in a && inEnum(a.device_category, CP_DeviceTypeValue));

}



export type CustomParamsKey = keyof CustomParams;


/**
 * Each dictionary defines how custom param keys are translated during serialization
 */
export type CustomParamDictionary = { [k in CustomParamsKey]: string };



/**
 * standard custom param dictionary
 */
export const StandardCustomParamDictionary: CustomParamDictionary = {
    type: "type",
    page: "pagina",
    age: "fp_e",
    sex: "fp_s",
    paragraph_number: "n_parag",
    url: "url",
    user: "user",
    content: "contenuto",
    story: "fp_story",
    inappbrowser: "inappbrowser",
    site: "site",
    utm_medium: "utm_medium",
    utm_source: "utm_source",
    utm_campaign: "utm_campaign",
    fanpage: "fanpage",
    category: "category",
    device_category: "device_category",
    amznbid: "amznbid",
    num_session_page_views: "n_pv_session",
    fptst: "fptst",
    audio: "audio",
    vpmute: "vpmute",
    contesto_browser: "contesto_browser"
};


